// import styled, { keyframes } from "styled-components";

// const Modal = ({ isOpen, onClose, children, title = "👤 Modal Title" }) => {
//   if (!isOpen) return null;

//   return (
//     <ModalOverlay>
//       <ModalWrapper>
//         <ModalContainer>
//           <Header>
//             <Title>{title}</Title>
//             <StyledClose onClick={onClose}>❌</StyledClose>
//           </Header>
//           <Content>{children}</Content>
//         </ModalContainer>
//       </ModalWrapper>
//     </ModalOverlay>
//   );
// };

// // ✨ Smooth entry animation
// const slideFadeIn = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const ModalOverlay = styled.div`
//   position: fixed;
//   inset: 0;
//   background: rgba(0, 0, 0, 0.55);
//   z-index: 5000;
//   display: flex;
//   justify-content: center;
//   overflow-y: auto;
//   padding: 3rem 1rem 2rem; /* 👈 Adds spacing so it's never under navbar */
// `;

// const ModalWrapper = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: flex-start; /* 👈 Starts *below* navbar */
// `;

// const ModalContainer = styled.div`
//   background: ${({ theme }) => theme === "dark" ? "#1f1f1f" : "#fff"};
//   color: ${({ theme }) => theme === "dark" ? "#f0f0f0" : "#222"};
//   border-radius: 14px;
//   padding: 1.5rem 1rem;
//   width: 100%;
//   max-width: 480px;
//   animation: ${slideFadeIn} 0.3s ease-out;
//   box-shadow: 0 24px 48px rgba(0, 0, 0, 0.25);
//   position: relative;
// `;

// const Header = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// `;

// const Title = styled.h3`
//   font-size: 1.1rem;
//   font-weight: 600;
//   margin: 0;
//   display: flex;
//   align-items: center;
//   gap: 0.4rem;
// `;

// const StyledClose = styled.button`
//   background: transparent;
//   border: none;
//   font-size: 1.2rem;
//   cursor: pointer;
//   color: #888;

//   &:hover {
//     color: #ff4d4f;
//     transform: scale(1.1);
//   }

//   transition: all 0.2s ease-in-out;
// `;

// const Content = styled.div`
//   margin-top: 1rem;
// `;

// export default Modal;
import styled, { keyframes } from "styled-components";

const Modal = ({ isOpen, onClose, children, title = "👤 Modal Title" }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalWrapper>
        <ModalContainer>
          <Header>
            <Title>{title}</Title>
            <StyledClose onClick={onClose}>❌</StyledClose>
          </Header>
          <Content>{children}</Content>
        </ModalContainer>
      </ModalWrapper>
    </ModalOverlay>
  );
};

// ✨ Entry animation
const slideFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 5000;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  padding: 3rem 1rem 2rem;
`;

const ModalWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const ModalContainer = styled.div`
  background: ${({ theme }) => (theme === "dark" ? "#1f1f1f" : "#fff")};
  color: ${({ theme }) => (theme === "dark" ? "#f0f0f0" : "#222")};
  border-radius: 14px;
  padding: 1.5rem 1rem;
  width: 100%;
  max-width: clamp(320px, 90vw, 720px); /* 👈 Up to 720px wide */
  animation: ${slideFadeIn} 0.3s ease-out;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.25);
  position: relative;
  overflow-x: auto;
  max-height: 90vh;

  /* Optional resizable behavior on desktop */
  resize: both;
  min-height: 300px;

  @media (max-width: 640px) {
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
    max-width: 100vw;
    padding: 2rem 1rem 1rem;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;

  @media (max-width: 400px) {
    font-size: 1rem;
  }
`;

const StyledClose = styled.button`
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #888;

  &:hover {
    color: #ff4d4f;
    transform: scale(1.1);
  }

  transition: all 0.2s ease-in-out;
`;

const Content = styled.div`
  margin-top: 1rem;
  overflow-y: auto;
  max-height: 60vh;

  @media (max-width: 640px) {
    max-height: calc(100vh - 100px); /* more scroll room on mobile */
  }

  /* Makes inner tables or wide content scrollable */
  & > * {
    max-width: 100%;
    overflow-x: auto;
  }
`;

export default Modal;
